export default __webpack_public_path__ + "static/media/footebol-bg-grande.af8f70cc.png";